import WithAuthCheck from "../WithAuthCheck/index";
import { compose, withProps } from "recompose";
import WithResizeListener from "../WithResizeListener/index";
import WithContractSocket from "../WithContractSocket";
import SidebarLayout from "../SidebarLayout";
import routes from "../../routes/app";

export default compose(
  WithAuthCheck,
  WithResizeListener,
  WithContractSocket,
  withProps(props => {
    return {
      routes
    };
  })
)(SidebarLayout);
